import axios from 'axios';

import SpecComment from './SpecComment';
import { BasicUserInfo } from '../interfaces/BasicUserInfo';
import { PagingResult } from '../interfaces/pagination';

export interface SpecCommentReportType {
  id: number
  reporterId: string
  reporter?: BasicUserInfo
  commentId: number
  comment?: SpecComment
  description: string
  resolved: boolean
  createdAt: string
  updatedAt: string
}

class SpecCommentReport implements SpecCommentReportType {
  id: number
  reporterId: string
  reporter?: BasicUserInfo
  commentId: number
  comment?: SpecComment
  description: string
  resolved: boolean
  createdAt: string
  updatedAt: string

  constructor(report: SpecCommentReportType) {
    this.id = report.id;
    this.reporterId = report.reporterId;
    this.reporter = report.reporter;
    this.commentId = report.commentId;
    this.comment = report.comment ? new SpecComment(report.comment) : report.comment;
    this.description = report.description;
    this.resolved = report.resolved;
    this.createdAt = report.createdAt;
    this.updatedAt = report.updatedAt;
  }

  // creates new spec comment report
  static async create(specComment: Partial<SpecCommentReportType>): Promise<SpecCommentReport> {
    const { data } = await axios.post<SpecCommentReportType>('/spec/comment-report', specComment);
    return new SpecCommentReport(data);
  }

  // returns spec comment report list
  static async find(query?: { [key: string]: any }): Promise<PagingResult<SpecCommentReport>> {
    const { data } = await axios.get<PagingResult<SpecCommentReportType>>('/spec/comment-report/list', {
      params: query
    });
    return { ...data, items: data.items.map(s => new SpecCommentReport(s)) };
  }

  // static method for resolving report
  static async resolve(query: { id: number }) {
    const { data } = await axios.post('/spec/comment-report/resolve', {}, {
      params: query
    });
    return data;
  }

  // resolve report
  async resolve() {
    return SpecCommentReport.resolve({ id: this.id });
  }
}

export default SpecCommentReport;
